import { FoodItem } from "@/root/types";
import { motion } from "framer-motion";
import Action from "@/components/food-item/action";
import Image from "next/image";
import { useState } from "react";
import ImageModal from "../image-modal";
import { getInitials } from "@/shared/lib/utils/functions"
import * as pixel from "@/lib/fpixel";
import { useIp } from "@/context/user-context";
export const SingleFoodItem = ({
  item
}: {
  item: FoodItem;
}) => {
  const { id, title, price, calories, imageURL, description, category } = item;
  const [isModalOpen, setModalOpen] = useState(false);
  const ip = useIp();

  const handleModalOpen = (e: any) => {
    e.stopPropagation();
    setModalOpen(true);

    pixel.event('ViewContent', {
      content_ids: [id],
      content_name: title,
      content_type: 'image',
      content_url: imageURL,
      user_data: {
        client_ip_address: ip,
        client_user_agent: navigator.userAgent
      }
    });
  };
  const handleModalClose = (e: any) => {
    e.stopPropagation();
    setModalOpen(false);
  };

  const hasVariations = item.variationPrices && Array.isArray(item.variationPrices) && item.variationPrices.length > 0;

  return (
    <div
      key={`item-${item.id}`}
      id={`item-${item.id}`}
      className="flex w-full flex-col lg:w-[calc(50%-1rem)] lg:bg-gray-100 rounded-md rounded-r-none shadow-even-md lg:shadow-none lg:rounded-md"
    >
      <Action food={item}>
        <div className="w-full p-3 flex flex-row gap-4 support-gap-4 items-center h-[100%] ">
          {
            imageURL && <Image
              width={180}
              height={180}
              src={item.imageURL || "/images/logo-grill.png"}
              alt={item.title}
              onClick={item.imageURL ? handleModalOpen : undefined}
              className="rounded-[50%] w-[48px] h-[48px] object-cover mb-[auto]"
            />

          }

          {
            !imageURL && <div
              className="rounded-[50%] text-[20px] bg-gray-300 flex w-[48px] min-w-[48px] h-[48px] items-center justify-center text-white font-bold mb-[auto]">{getInitials(item.title)}</div>
          }

          <div style={{ pointerEvents: "none" }} className="w-full pr-[20px] h-[100%]">
            <div className="w-full flex flex-col h-[100%]">
              <div className="flex flex-col">
                <h1 className="font-bold text-[18px] flex-1 pr-[10px]">{item.title}</h1>
                {!hasVariations && <p className="mb-2 white text-primary font-bold text-[16px] whitespace-nowrap">{item.price} $</p>}
              </div>
              {description && <p dangerouslySetInnerHTML={{ __html: description }} className="text-[16px] text-black text-opacity-50"></p>}
              {hasVariations && <div className="flex flex-row gap-6 pt-[20px] mt-[auto]">
                {item.variationPrices.map((variation, index) => {
                  return (
                    <div id={`variation-price-${item.id}-${index}`} key={`variation-price-${item.id}-${index}`} className="flex w-full flex-col items-start gap-1">
                      <label className="font-bold text-primary">{variation.label}:</label>
                      <span className="font-bold">{Number(variation.price) > 0 ? `${variation.price}$` : '-'}</span>
                    </div>
                  );
                })}
              </div>}
            </div>
          </div>

          {item.imageURL && <ImageModal
            isOpen={isModalOpen}
            onClose={handleModalClose}
            imageURL={item.imageURL}
            alt={item.title}
          />}
        </div>
      </Action>
    </div>
  );
};